/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackUpdateResponseFeedback } from "../../funcs/llmFeedbackUpdateResponseFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateResponseFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackUpdateResponseFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-update-response-feedback",
  description: `Update existing response feedback

Updates or modifies existing feedback for a specific agent response. Useful for allowing users to revise their initial submissions.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackUpdateResponseFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
